(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prex-brand-filter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const link = event.target.closest('.prex-brand-filter__options a');
    if (!link) return;
    const destination = new URL(link.href);
    const parameters = new URLSearchParams(window.location.search);
    parameters.delete('page');
    destination.search = parameters.toString();
    link.href = destination.href;
  });

  } catch(e) { console.error(e); }
})();
})();
